





































































import { ApplipcationStoreType, Package } from "@/enums/enums";
import { CheckIsDevelop } from "@/helper/shareHelper";
import { CheckMerchantAFPPackage, MerchantId, CheckMerchantPackage } from "@/helper/userHelper";
import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";
import ModalLinePEAKConnect from "./ModalLinePEAKConnect.vue";

const StoreLogIn = namespace("LogIn");

@Component({ components: { ModalLinePEAKConnect } })
export default class ApplicationStore extends Vue {
  private isShowApplicationStore = false;
  private showModalLinePEAKConnect = false;
  private blobUrl = process.env.VUE_APP_PeakBlobStorage?.toString() ?? "";
  private isDevelop = CheckIsDevelop();
  private showDueDatePeakBoard = false;
  private isMerchantPackageAFP = CheckMerchantAFPPackage();
  private isFreeTrialPackage = CheckMerchantPackage([Package.Trial]);

  get isCanUsePeakPayroll() {
    return this.$can("access", "PeakPayroll") && !this.isMerchantPackageAFP;
  }

  get isCanUsePeakBoard() {
    return this.$can("access", "PeakBoard") && !this.isMerchantPackageAFP;
  }

  get isCanUsePeakTax() {
    return this.$can("access", "PeakTax");
  }

  get isCanUseOldPeak() {
    return !this.isMerchantPackageAFP;
  }
  get isCanUsePeakConnect() {
    return !this.isMerchantPackageAFP;
  }

  @StoreLogIn.Action
  private DoRedirectByApplipcationStore!: (applipcationStoreType: ApplipcationStoreType) => void;

  public Hide() {
    this.isShowApplicationStore = false;
  }
  public RedirectToPeak() {
    this.Hide();
    this.DoRedirectByApplipcationStore(ApplipcationStoreType.Peak);
  }
  public RedirectToNewPeak() {
    this.Hide();
    this.DoRedirectByApplipcationStore(ApplipcationStoreType.NewPeak);
  }
  public RedirectToPeakPayroll() {
    this.Hide();
    this.DoRedirectByApplipcationStore(ApplipcationStoreType.Payroll);
  }
  public RedirectToPeakBoard() {
    this.Hide();
    this.DoRedirectByApplipcationStore(ApplipcationStoreType.Board);
  }
  public RedirectToPeakAsset() {
    this.$router.push({
      name: "home",
      query: { emi: MerchantId().PeakEncryption() },
    });
    this.Hide();
  }
  public RedirectToPeakTax() {
    this.Hide();
    this.DoRedirectByApplipcationStore(ApplipcationStoreType.Tax);
  }
  public DoShowModalLinePEAKConnect() {
    this.showModalLinePEAKConnect = true;
    this.Hide();
  }
  public RedirectToUpgrade() {
    window.open(`${process.env.VUE_APP_PeakAccount}setting/billing?emi=${MerchantId().PeakEncryption()}`);
  }
}
